import { render, staticRenderFns } from "./PLList.vue?vue&type=template&id=05e539a3&scoped=true&"
import script from "./PLList.vue?vue&type=script&lang=js&"
export * from "./PLList.vue?vue&type=script&lang=js&"
import style0 from "./PLList.vue?vue&type=style&index=0&id=05e539a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e539a3",
  null
  
)

export default component.exports